export default class AltVideoElement extends HTMLElement {
  constructor() {
    super();
  }

}
customElements.define('alt-video', AltVideoElement);